import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=34dfcb46&scoped=true&"
import script from "./withdrawal.vue?vue&type=script&lang=ts&"
export * from "./withdrawal.vue?vue&type=script&lang=ts&"
import style0 from "./withdrawal.vue?vue&type=style&index=0&id=34dfcb46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dfcb46",
  null
  
)

export default component.exports